<template>
  <div class="application-item list-item with-icon">
    <v-list-item-avatar tile color="grey">
      <v-icon color="black">mdi-text-box-outline</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <div class="item-right">
        <div class="description">
          <div class="d-flex flex-column">
            <span class="font-weight-bold">{{ booking.title }}</span>
            <div class="mt-1">
              {{ booking.salaryBandLower | currency("GBP") }} -
              {{ booking.salaryBandUpper | currency("GBP") }}
            </div>
          </div>
        </div>
        <Chip
          class="chip--status"
          shrink
          :color="getApplicationStatusColor(application)"
        >
          {{ getApplicationStatusTitle(application) | upperCase }}
        </Chip>
      </div>
    </v-list-item-content>
  </div>
</template>

<script>
import {
  getApplicationStatusColor,
  getApplicationStatusTitle
} from "@/utils/applications";
import Chip from "@/components/common/Chip";

export default {
  props: {
    application: {
      type: Object,
      required: true
    }
  },
  components: {
    Chip
  },
  computed: {
    booking() {
      return this.application.booking;
    }
  },
  methods: {
    getApplicationStatusTitle,
    getApplicationStatusColor
  }
};
</script>
<style lang="scss">
.application-item {
  .v-avatar.v-list-item__avatar {
    background-color: rgba(#7a7a7a, 0.1) !important;
    border-radius: 4px;
  }
}
</style>
